import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import apiService from "../services/api";

const PendingApprovalPage = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(apiService.getUser());

  useEffect(() => {
    const unsubscribe = apiService.onAuthChange((p) => {
      if (!p) {
        navigate("/auth");
        return;
      }
      if (p.role === "EXPERT") {
        navigate("/dashboard");
        return;
      }
      setProfile(p);
    });
    return unsubscribe;
  }, [navigate]);

  const handleSignOut = async () => {
    await apiService.logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-indigo-900 to-slate-900 flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-lg bg-white/10 backdrop-blur-lg rounded-2xl p-10 shadow-2xl border border-white/20 text-center"
      >
        <div className="text-6xl mb-4">⏳</div>
        <h1 className="text-3xl font-bold text-white mb-3">Awaiting approval</h1>
        <p className="text-gray-300 mb-6">
          Your account
          {profile?.email ? <> (<span className="text-indigo-200">{profile.email}</span>)</> : null}{" "}
          isn't approved for the expert annotation dashboard yet.
        </p>
        <p className="text-gray-400 text-sm mb-8">
          An administrator needs to grant you access. Once they do, sign out and back in to start annotating.
        </p>
        <button
          type="button"
          onClick={handleSignOut}
          className="px-6 py-3 rounded-lg bg-red-500 hover:bg-red-600 text-white font-medium transition-colors"
        >
          Sign out
        </button>
      </motion.div>
    </div>
  );
};

export default PendingApprovalPage;
